import React, { useRef, useEffect, useMemo } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import ISecteur from "../../models/ISecteur";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionSecteursProps {
  isModeSelection?: boolean,
}

export default function GestionSecteurs({ isModeSelection }: IGestionSecteursProps) {
  const clientFormDataSource = useCustomDataSource<ISecteur, ISecteur>({ path: "secteur", primaryKey: "idSecteur" });
  const { setMainForm, selectedDataRow: selectedSecteur, mode, setMode, isFieldModifier, setIsFieldModifier } = clientFormDataSource;
  const formRef = useRef<FormRef>(null);
  const { setSelectedValue } = useContextPopupPage();

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  const actifOptions = useMemo(() => (
    { text: "Actif" }
  ), [])
  const chasseOptions = useMemo(() => (
    { text: "Chasse" }
  ), [])
  const pecheOptions = useMemo(() => (
    { text: "Pêche" }
  ), [])
  const disponibleEnLigneOptions = useMemo(() => (
    { text: "Disponible en ligne" }
  ), [])

  return (
    <FormListBase data={clientFormDataSource}>
      <FormListBaseGrid dataSource={clientFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture);
          }
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}>
        <Column key={"grid-col-nom-secteur"} dataField={"nomSecteur"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-peche"} dataField={"peche"} caption="Pêche" allowHiding={false} />
        <Column key={"grid-col-chasse"} dataField={"chasse"} caption="Chasse" allowHiding={false} />
        <Column key={"grid-col-superficie"} dataField={"superficie"} caption="Superficie" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedSecteur?.nomSecteur || ''} `} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedSecteur || {} as ISecteur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={(e) => setIsFieldModifier(true)}>
              <GroupItem colCount={5}>
                <GroupItem colSpan={3}>
                  <SimpleItem key={"frm-nomSecteur"} dataField={"nomSecteur"} />
                  <SimpleItem key={"frm-superficie"} dataField={"superficie"} editorType={'dxNumberBox'} />
                  <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
                    editorOptions={actifOptions}
                  >
                    <Label visible={false} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={"Type"} colSpan={2}>
                  <SimpleItem key={"frm-chasse"} dataField={"chasse"} editorType={"dxCheckBox"}
                    editorOptions={chasseOptions}
                  >
                    <Label visible={false} />
                  </SimpleItem>
                  <SimpleItem key={"frm-peche"} dataField={"peche"} editorType={"dxCheckBox"}
                    editorOptions={pecheOptions}
                  >
                    <Label visible={false} />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Internet">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedSecteur || {} as ISecteur} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <SimpleItem key={"frm-disponible-en-ligne"} dataField={"disponibleEnLigne"} editorType={"dxCheckBox"}
                editorOptions={disponibleEnLigneOptions}
              >
                <Label visible={false} />
              </SimpleItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedSecteur || {} as ISecteur} /></TabItem>
        </FormListBaseTab> : null}
    </FormListBase>
  );
}